import React from "react";
import { Phone } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";
import { COMPANY } from "@/i18n/translations";

export const CallFloat = () => {
  const { t, dir } = useLang();
  const sideClass = dir === "rtl" ? "left-5" : "right-5";
  return (
    <a
      data-testid="call-float"
      href={`tel:${COMPANY.phone}`}
      aria-label="Call now"
      className={`fixed bottom-[88px] ${sideClass} z-50`}
    >
      <span className="flex items-center gap-2 rounded-full bg-slate-900 text-white shadow-xl px-4 py-3 hover:bg-slate-700 transition-colors">
        <Phone className="w-4 h-4" />
        <span className="hidden sm:inline text-sm font-semibold">{t("common.callNow")}</span>
      </span>
    </a>
  );
};
